import { Controller } from 'stimulus';
import createEvent from '@/helpers/createEvent';

function getAttrForElement(element, key, fallback) {
  return element.getAttribute(key)
    ? parseInt(element.getAttribute(key), 10)
    : fallback;
}

function getInputReach(inputElement) {
  return {
    input: parseInt(inputElement.value, 10),
    min: getAttrForElement(inputElement, 'min', 0),
    max: getAttrForElement(inputElement, 'max', Infinity),
  };
}

class ControlledInput extends Controller {
  /**
   * Validate the input field value
   */
  static validateInput(inputElement) {
    const { input, min, max } = getInputReach(inputElement);
    let mutatedInput = input;
    let mutated = 'none';

    if (mutatedInput < min) {
      mutatedInput = min;
      mutated = 'min';
    }

    if (mutatedInput > max) {
      mutatedInput = max;
      mutated = 'max';
    }

    if (mutatedInput !== input) {
      inputElement.value = mutatedInput;
      createEvent(inputElement, 'change');
    }

    return mutated;
  }

  connect() {
    this.checkDisabledStates(this.inputTarget);
  }

  onDecrementClick() {
    this.incrementInput(-1);
  }

  onIncrementClick() {
    this.incrementInput(1);
  }

  onInputChange() {
    this.handleNotification(ControlledInput.validateInput(this.inputTarget));

    this.checkDisabledStates(this.inputTarget);
  }

  handleNotification(state) {
    const isMaxReached = state === 'max';

    if (this.data.get('maximum-quantity-notification') && isMaxReached) {
      this.notificationTarget.textContent = this.data.get('maximum-quantity-notification');
      this.notificationTarget.classList.add('is-visible');
      return;
    }

    this.notificationTarget.classList.remove('is-visible');
  }

  /**
   * Increment the input value
   */
  incrementInput(inc) {
    const { input } = getInputReach(this.inputTarget);

    this.inputTarget.value = input + inc;
    createEvent(this.inputTarget, 'change');

    this.handleNotification(ControlledInput.validateInput(this.inputTarget));
    this.checkDisabledStates(this.inputTarget);
  }

  /**
   * Check the availability of the plus and min buttons
   */
  checkDisabledStates(inputElement) {
    const { input, min, max } = getInputReach(inputElement);

    this.decrementButtonTarget[input <= min ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true');
    this.incrementButtonTarget[input >= max ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true');
  }
}

ControlledInput.targets = [
  'input',
  'button',
  'incrementButton',
  'decrementButton',
  'notification',
];

export default ControlledInput;
